import { trackEvent } from "../shared/mixpanel";
import platformClient from "./platformIntegrations";

export const getBusinessPages = async () => {
    const response = await platformClient.get("external-ingestion/v1/api/org/business-pages");
    return response.data;
};

export const saveBusinessPage = async (platform, payload) => {
    const response = await platformClient.put(`external-ingestion/v1/api/org/business-pages/${platform.toLowerCase()}`, payload);
    trackEvent("Business Page Saved", { platform });
    return response.data;
};

export const deleteBusinessPage = async (platform) => {
    const response = await platformClient.delete(`external-ingestion/v1/api/org/business-pages/${platform.toLowerCase()}`);
    trackEvent("Business Page Disconnected", { platform });
    return response.data;
};

export const connectBusinessPage = async (platform) => {
    const response = await platformClient.post(`external-ingestion/v1/api/org/business-pages/${platform.toLowerCase()}/connect`);
    trackEvent("Business Page Connect Started", { platform });
    return response.data;
};

export const saveBusinessPageManual = async (platform, payload) => {
    const response = await platformClient.post(
        `external-ingestion/v1/api/org/business-pages/${platform.toLowerCase()}/manual`,
        payload
    );
    trackEvent("Business Page Saved", { platform, mode: "manual" });
    return response.data;
};

export const getAvailableBusinessPages = async (platform, transactionId) => {
    const response = await platformClient.get(
        `external-ingestion/v1/api/org/business-pages/${platform.toLowerCase()}/available-pages`,
        { params: { transactionId } }
    );
    return response.data;
};

export const selectBusinessPage = async (platform, payload) => {
    const response = await platformClient.post(
        `external-ingestion/v1/api/org/business-pages/${platform.toLowerCase()}/select`,
        payload
    );
    trackEvent("Business Page Selected", { platform });
    return response.data;
};

export const getLeaderPages = async () => {
    const response = await platformClient.get("external-ingestion/v1/api/org/leader-pages");
    return response.data;
};

export const getReconciliationLogs = async () => {
    const response = await platformClient.get("external-ingestion/v1/api/org/reconciliation-logs");
    return response.data;
};

